"use client";
import {
  useMenuStore
} from "../__chunks/XZTI53XS.js";
import {
  MenuContextProvider
} from "../__chunks/ZVTAGWLT.js";
import "../__chunks/BPJQU32H.js";
import "../__chunks/WJUQFF4Z.js";
import "../__chunks/HVBTERMS.js";
import "../__chunks/DYZ3QKCZ.js";
import "../__chunks/RA2MZPUM.js";
import "../__chunks/J4JPXPLD.js";
import "../__chunks/EDI7THRR.js";
import "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import "../__chunks/I6MSISV2.js";
import "../__chunks/T3LVAWXA.js";
import "../__chunks/BJY6QMBB.js";
import "../__chunks/QX2CMDZ5.js";
import "../__chunks/D6UA6CB7.js";
import "../__chunks/S67MTDSB.js";
import "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-provider.tsx
import { jsx } from "react/jsx-runtime";
function MenuProvider(props = {}) {
  const store = useMenuStore(props);
  return /* @__PURE__ */ jsx(MenuContextProvider, { value: store, children: props.children });
}
export {
  MenuProvider
};
